import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './DoctorNotice.css';
import { formatAccessWbar } from '../../../../components/Util/DateFormat';
import axios from 'axios';
import Swal from 'sweetalert2';
import downloadIcon from '../../../../assets/icons/download.png';
import { fileDownload } from '../../../../functions/Functions';
import { getServerBaseUrl } from '../../../../utils/portConfig';

function DoctorNotice ({ patientData }) {

  // State 변수 선언
  const [patientId, setPatientId] = useState('');
  const [drNoticeData, setDrNoticeData] = useState([]);
  const navigate = useNavigate();

  const API_SERVER_URL = `${getServerBaseUrl()}/api/v1`;
  const token = localStorage.getItem('token');

  // 환자 데이터가 변경될 때 실행되는 useEffect
  useEffect(() => {
    if (patientData) {
      setPatientId(patientData != null ? patientData.id : null);
    } 
  }, [patientData]);

  // 환자 ID가 변경될 때 실행되는 useEffect 
  useEffect(() => {
    if(patientId) {
      getDrNoticeList();
    }
  }, [patientId]);

  // 의사 소견서 목록을 가져오는 함수
  const getDrNoticeList = async () => {
    try {
      const response = await axios.get(`${API_SERVER_URL}/notice/${patientId}`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const drNoticeDateData = response.data.map(item => ({
        value: item.id,
        label: formatAccessWbar(item.modifiedDt),
        comments: item.comments,
        doctorId: item.doctorId,
        attachments: item.attachments
      }));

      setDrNoticeData(drNoticeDateData);

    } catch (error) {
      console.error("Patient Date Category fetch error:", error);
      // 에러가 발생하면 drNoticeData를 null로 설정
      setDrNoticeData([]);
    }
  };

  //환자정보전달 - 등록버튼
  const regPatientInfoDateButton = () => {
      navigate('/', {state: { setActiveMenu: '환자정보전달', tabFlag:'소견등록' }});
  };

  // 환자정보전달 - 삭제 버튼
  const deletePatientInfo = async (id) => {
    const confirmationResult = await Swal.fire({
      icon: 'question',
      title: '환자정보 전달사항 삭제',
      text: '전달된 환자정보를 삭제하시겠습니까?',
      showCancelButton: true,
      confirmButtonText: '확인',
      cancelButtonText: '취소',
      customClass: {
        popup: 'custom-swal-popup'
      }
    });

    if(confirmationResult.isConfirmed) {
      try{
        const response = await axios.delete(
          `${API_SERVER_URL}/notice/${id}/delete`,
          {
            headers: {Authorization: `Bearer ${token}` }
          }
        );

        if(response.status === 204) {
          const successResult = await Swal.fire({
            icon: 'success',
            title: '성공',
            text: '정보가 삭제되었습니다.',
            confirmButtonText: '확인',
            customClass: {
              popup: 'custom-swal-popup'
            }
          });

          if(successResult.isConfirmed){
            getDrNoticeList();
          }
        } else {
          await Swal.fire({
            icon: 'error',
            title: '실패',
            text: '삭제 실패. 다시 시도해주세요.',
            confirmButtonText: '확인',
            customClass: {
              popup: 'custom-swal-popup'
            }
          });
        }
      } catch(error) {
        console.error('Error deleting Doctor Notice: ', error);
        if(error.response) {
          const responseData = error.response.data;
          if(responseData) {
            Swal.fire({
              icon: 'error',
              title: '투표 삭제 오류',
              text: responseData,
              customClass: {
                popup: 'custom-swal-popup'
              }
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: '서버 응답 오류',
              text: `서버 응답 오류: ${error.response.status}`,
              customClass: {
                popup: 'custom-swal-popup'
              }
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: '서버 응답이 없습니다.',
            text: '서버 응답이 없습니다.',
            customClass: {
              popup: 'custom-swal-popup'
            }
          });
        }
      }
    }
  }
  
  // 환자정보전달 첨부파일 보이게 하는 곳
  return (
    <div className='secret-container'>
      {drNoticeData.length === 0 ? (
        <div className="secret-scrollable-area">
          <div className="gosiWrapper-guide">
            <p>작성한 내용이 없습니다.</p>
          </div>
        </div>
      ) : (
        <div className="secret-scrollable-area">
          {drNoticeData.map((drnData, dIndex) => (
            <div className='drnotice-item-group' key={dIndex}>
              <div className="checklist-item-date">
                {drnData.label}
              </div>
              <div className="drnotice-item">
                <div className='drnotice-item-contents align-left' dangerouslySetInnerHTML={{__html: drnData.comments}}></div>
                <div className="drnotice-footer">
                  {drnData.attachments &&(
                    drnData.attachments.map((attachment, aIndex) => (
                      <div className="drnotice-file-body" onClick={() => fileDownload(attachment, token)}>
                        <span>첨부파일: &nbsp;</span>
                        <a
                          className="attachment-download-link"
                        >
                          <span className="drnotice-attachment-filename">{attachment.filename}</span>
                        </a>
                      </div>
                    ))
                  )}
                  <div className='drnotice-item-result'>
                    <button className='secret-delete-button' onClick={() => deletePatientInfo(drnData.value)}>삭제</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className='submit-button-container'>
        <button type='button' className='drnotice-reg-button' onClick={regPatientInfoDateButton}>등록</button>
      </div>
    </div>
  );
}

export default DoctorNotice;
